import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { ShortageFragmentFragmentDoc } from '@packages/gql/generated/shopping/ShortageFragmentFragmentDoc';
import type { FlagProps } from '@packages/shared';
import { Flag } from '@packages/shared';
import { useIntl } from 'react-intl';
import { useConfig } from '@packages/utilities';
import type { Config } from '@packages/config';
import { shortageMessages } from './messages';

/* GraphQL */ `
  fragment ShortageFragment on Availability {
    limitedStock
  }
`;

type ShortageProps = {
  data: FragmentType<typeof ShortageFragmentFragmentDoc>;
};

function getShortageVersionProps(
  version: Config['product']['shortageVersion'],
): Omit<FlagProps, 'text'> {
  switch (version) {
    case 'Version2':
      return {
        type: 'contrast',
      };
    default: {
      return {
        type: 'neutral',
      };
    }
  }
}

export const Shortage = ({ data }: ShortageProps) => {
  const { limitedStock } = getFragmentData(ShortageFragmentFragmentDoc, data);
  const { formatMessage } = useIntl();
  const {
    product: { shortageVersion },
  } = useConfig();

  return shortageVersion !== null && limitedStock ? (
    <Flag
      text={formatMessage(shortageMessages.text)}
      {...getShortageVersionProps(shortageVersion)}
    />
  ) : null;
};
